import { Routes } from '@angular/router';
import { LoginPage } from './features/public/login/login.page';
import { NotFoundPage } from './features/public/not-found/not-found.page';
import { LoginGuard } from './guards/login.guard';
import { AuthGuard } from './guards/auth.guard';
import { ResetPasswordPage } from './features/public/reset-password/reset-password.page';
import { RegisterPage } from './features/public/register/register.page';
import { VerifyEmailPage } from './features/public/verify-email/verify-email.page';
import { ImpersonatePage } from './features/public/impersonate/impersonate.page';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginPage,
    canActivate: [LoginGuard]
  },
  {
    path: 'register',
    component: RegisterPage,
    canActivate: [LoginGuard]
  },
  {
    path: 'reset-password',
    component: ResetPasswordPage,
    canActivate: [LoginGuard]
  },
  {
    path: 'verify-email',
    component: VerifyEmailPage,
    canActivate: [LoginGuard]
  },
  {
    path: 'impersonate',
    component: ImpersonatePage
  },
  {
    path: 'p',
    pathMatch: 'prefix',
    loadChildren: () => import('./features/private/private.routes').then(m => m.routes),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    component: NotFoundPage
  }
];
